import React from 'react';
import { Glyphicon,  Modal, Button } from "react-bootstrap";
import classes from './ModalForm.css';
import Input from '../Input/Input';

const alert = (props) => {
    let confirmElement = null;
    let formInser = null;
    const inputClasses = [classes.InputElement];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }
    const formElementsArray = [];
    for (let key in props.objform) {
        formElementsArray.push({
            id: key,
            config: props.objform[key]
        });
    }
    formInser = 
            <form>
        {formElementsArray.map(formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        changed={(event) => props.inputEvent(event, formElement.id)} />
                ))}
            </form>
    confirmElement = 
        <div>
        <Modal show={props.showmodal} onHide={props.clickedCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{formInser}</Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary" onClick={props.clickedOk}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
    return (
        <div>
            {confirmElement}
        </div>
    );
};

export default alert;